<template>
  <data-input
    ref="project"
    v-model="project"
    :data-type="{ name: 'select' }"
    :items="projectsList"
    :menu-props="{
      offsetY: true,
      nudgeBottom: 35,
      minWidth: 250,
    }"
    :attach="true"
    :auto-convert-select="false"
    class="tw:hidden-select-activator"
  >
    <template v-if="areProjectsLoading" #[`no-data`]>
      <div class="tw:py-2.5">
        <main-loader />
      </div>
    </template>
    <template #prepend>
      <base-button type="alternative" size="sm" :toggled="!!project" @click="onProjectsClick">
        <div class="tw:w-18 tw:max-w-18 tw:text-left tw:truncate">
          {{ currentProjectName ?? $i18n.t('navbar.project') }}
        </div>
        <template #appendIcon>
          <span class="tw:flexrow-0.5 tw:items-center">
            <v-icon ref="close" :class="{ 'tw:invisible': !project }" small @click="project = null"> mdi-close </v-icon>
            <v-icon small class="expand-icon">mdi-chevron-down</v-icon>
          </span>
        </template>
      </base-button>
    </template>
  </data-input>
</template>

<script>
import { call, get, sync } from 'vuex-pathify';

import MainLoader from '@/components/MainLoader';
import DataInput from '@/components/DataInput';

export default {
  name: 'OzeProjectFilterSelector',
  components: {
    DataInput,
    MainLoader,
  },
  data: () => ({
    projectsList: [],
    areProjectsLoading: false,
  }),
  computed: {
    ozeProjectsNameAttribute: get('layers/metadata@:ozeProjectsDatasourceName?.attributes_schema.desc_attribute_name'),
    ozeProjectsDatasourceName: get('admin/modulesMapping@oze.oze_projects_datasource.datasource'),
    project: sync('layers/ozeFilterProjectId'),
    layersFilters: get('layers/layersFilters'),
    currentProjectName() {
      if (!this.project) return;
      return this.projectsList.find(p => p.value === this.project)?.text;
    },
    projectLayers: get('layers/flatProjectLayers'),
  },
  methods: {
    getDatasourceFeatures: call('layers/getV2DatasourceFeatures'),
    async fetchProjects() {
      if (this.projectsList.length) return;
      this.areProjectsLoading = true;
      try {
        const projects = await this.getDatasourceFeatures({
          datasource: this.ozeProjectsDatasourceName,
          payload: {
            attributes: [this.ozeProjectsNameAttribute],
          },
          params: {
            with_geometry: false,
          },
        });
        this.projectsList = projects.features.map(project => ({
          value: project.id,
          text: project.properties[this.ozeProjectsNameAttribute],
        }));
      } catch (error) {
        console.error(error);
      } finally {
        this.areProjectsLoading = false;
      }
    },
    onProjectsClick(e) {
      if (e.target === this.$refs.close.$el || this.$refs.close.$el.contains(e.target)) return;
      this.$refs.project?.$refs['data-input']?.toggleMenu();
      this.fetchProjects();
    },
  },
};
</script>
